import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import { colors } from "@ui/style/colors";
import React from "react";

type UiStyle = "warn" | "success";

interface BannerProps {
	text: string;
	icon: SVGComponent;
	uiStyle?: UiStyle;
	className?: string;
	onDelete?: () => void;
	rightComponent?: React.ReactNode;
}

export const Banner: React.FC<BannerProps> = ({
	text,
	icon: Icon,
	uiStyle = "warn",
	className,
	onDelete,
	rightComponent,
}) => (
	<BannerContainer uiStyle={uiStyle} className={className}>
		<MessageContainer>
			<Icon width={20} height={20} />
			{text}
			{rightComponent}
		</MessageContainer>
		{onDelete && <DeleteIcon className="pi pi-times" uiStyle={uiStyle} onClick={onDelete} />}
	</BannerContainer>
);

const MessageContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const BannerContainer = styled.div<{ uiStyle: UiStyle }>`
	display: grid;
	grid-template-columns: 1fr auto;
	place-items: center;
	gap: 10px;
	color: ${({ uiStyle }) => (uiStyle === "warn" ? colors.warnDark : colors.validationDark)};
	background-color: ${({ uiStyle }) => (uiStyle === "warn" ? colors.warn : colors.validation10)};
	padding: 10px 24px;
`;

const DeleteIcon = styled.i<{ uiStyle: UiStyle }>`
	cursor: pointer;
`;
